import { render } from "./TextMiddle.vue?vue&type=template&id=98efafda&scoped=true"
import script from "./TextMiddle.vue?vue&type=script&lang=js"
export * from "./TextMiddle.vue?vue&type=script&lang=js"

import "./TextMiddle.vue?vue&type=style&index=0&id=98efafda&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-98efafda"]])

export default __exports__